import React, { useCallback, useMemo, useState } from 'react';
import { Divider } from 'antd';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import LinkComponent from '../linkComponent';
import AuthModal from '../modal/authModal';

import { setActiveTabKey, setIsForgotPassword, setModalOpen } from '../../redux/slices/modalSlice';
import { useAuth } from '../../routes/authContext';
import { useRoles } from '../../helpers/roleLevelHelper';

import { headerItems } from '../../constants/headerConstants';
import PATHS from '../../routes/paths';

import { BRImages } from '../../assets/imgs';
import '../../assets/scss/index.scss';
import { checkAccess, PATH_PRIVILEGES } from '../../helpers/privilegeHelper';

const CustomHeader = () => {
  const dispatch = useDispatch();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const { isSuperAdmin, isAdmin, userRoleLevel } = useRoles();
  const isMediaActive = useMemo(() => location.pathname.startsWith('/media'), [location.pathname]);
  const isDashboardActive = useMemo(() => location.pathname.startsWith('/dashboard'), [location.pathname]);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const headerItemsFiltered = useMemo(() => {
    return headerItems.reduce((acc, item) => {
      if (item.title === 'Dashboard') {
        const dashboardPaths = [PATHS.USERS_TAB, PATHS.USAGE_TAB, PATHS.PUBLIC_EVENTS_TAB, PATHS.ADMIN_BIBLE_SEMINARS];
        const hasAccess = dashboardPaths.some(p => checkAccess(user, p, PATH_PRIVILEGES));
        if (hasAccess) {
          const accessiblePath = dashboardPaths.find(p => checkAccess(user, p, PATH_PRIVILEGES));
          acc.push({ ...item, path: accessiblePath });
        }
      } else {
        if (checkAccess(user, item.path, PATH_PRIVILEGES)) {
          acc.push(item);
        }
      }
      return acc;
    }, []);
  }, [user]);

  const showModal = useCallback(
    (tabKey) => {
      dispatch(setActiveTabKey(tabKey));
      dispatch(setIsForgotPassword(false));
      dispatch(setModalOpen(true));
    },
    [dispatch]
  );

  const handleLogout = useCallback(() => {
    logout();
    navigate(PATHS.HOME);
  }, [logout]);

  const headerBtnSection = useMemo(() => {
    if (!user || userRoleLevel === 1) {
      return (
        <div className='header-btn-section'>
          <LinkComponent
            title='Sign In'
            onClick={() => showModal('1')}
            className='header-btn-section-link manrope-16-regular text-white'
          />
          <LinkComponent
            title='Register'
            onClick={() => showModal('2')}
            className='header-btn-section-link manrope-16-regular text-white'
          />
        </div>
      );
    } else {
      return (
        <div className='header-btn-section'>
          <div className='flex items-center'>
            <img
              src={BRImages.HeaderIcons.UserCircleIcon}
              alt='user-icon'
              className='header-btn-icon'
            />
            <LinkComponent
              title={user?.displayName}
              className='pl-8 header-btn-section-link manrope-16-regular text-white'
              onClick={() => {
                if (user?.userProfile === 1) {
                  navigate(PATHS.PROFILE);
                  setIsMenuOpen(false);
                }
              }}
            />
          </div>
          <div className='flex items-center'>
            <img
              src={BRImages.HeaderIcons.LogoutIcon}
              alt='logout-icon'
              className='header-btn-icon'
            />
            <LinkComponent
              title='Logout'
              className='pl-8 header-btn-section-link manrope-16-regular text-white'
              onClick={handleLogout}
            />
          </div>
        </div>
      );
    }
  }, [user, showModal, handleLogout]);

  return (
    <div className='header-common w-100'>
      {headerBtnSection}
      <AuthModal />
      <Divider className='m-0' />
      <div className='header-menu-section'>
        <img
          src={BRImages.HeaderIcons.Logo}
          alt='logo'
          className='header-menu-logo cursor-pointer'
          onClick={() => navigate(PATHS.HOME)}
        />
        <div>
          <div className={`header-menu-icon d-none ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
            <img
              src={
                isMenuOpen ? BRImages.HeaderIcons.closeIcon : BRImages.HeaderIcons.HeaderMenuIcon
              }
              alt={isMenuOpen ? 'close-icon' : 'menu-icon'}
              className='menu-icon'
            />
          </div>
          <ul className={`header-menu-list flex my-8 pl-0 ${isMenuOpen ? 'active' : ''}`}>
            {headerBtnSection}
            {headerItemsFiltered.map(({ title, path }) => (
              <li key={title}>
                <LinkComponent
                  title={title}
                  className={`header-menu-list-item ${location.pathname === path || (title === 'Media' && isMediaActive) || (title === 'Dashboard' && isDashboardActive)
                    ? 'manrope-15-bold'
                    : 'manrope-15-medium'
                    }`}
                  onClick={() => {
                    navigate(path);
                    setIsMenuOpen(false);
                  }}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CustomHeader;
